export const PRICES = {
    PREMIUM_TOTAL_PRICE: 49.9,
    VAT_RATE: 0.23,
    SHIPPING_FEE: 4.9
}

export const getPlanLabel = (plan) => {
    if (plan === 'basic') {
        return 'ZÁKLAD';
    }
    if (plan === 'premium') {
        return 'PRÉMIUM';
    }
    return 'DEMO';
}

export const PAYMENT_METHOD = {
    GOPAY: 'gopay',
    CASH_ON_DELIVERY: 'dobierka'
}

export const PAYMENT_STATUS = {
    CREATED: 'CREATED',
    PAID: 'PAID'
}

export const calcTotal = (products) => {
    const subtotal = products.reduce((s, it) => s + it.qty * it.price, 0);
    const vat = (subtotal + PRICES.SHIPPING_FEE) * PRICES.VAT_RATE;
    const total = (subtotal + PRICES.SHIPPING_FEE) * (1 + PRICES.VAT_RATE);
    return { subtotal, shippingFee: PRICES.SHIPPING_FEE, vat, total };
}